(function () {
  /* =========================================================
     1) SELLER SEARCH AUTO-RESET (keep as-is)
     ========================================================= */
  function bindAutoResetForSellerSearch(root) {
    root = root || document;

    var forms = root.querySelectorAll('form.mp-search-bar');
    forms.forEach(function (form) {
      if (form.__wkAutoResetBound) return;
      form.__wkAutoResetBound = true;

      var input = form.querySelector('input[name="sp"]');
      if (!input) return;

      var prev = (input.value || '').trim();
      var timer = null;
      var isSubmitting = false;

      function submitForm() {
        if (isSubmitting) return;
        isSubmitting = true;

        try {
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            // Dispatch submit event first (some scripts listen to it)
            var ev = new Event('submit', { bubbles: true, cancelable: true });
            var cancelled = !form.dispatchEvent(ev);
            if (!cancelled) form.submit();
          }
        } finally {
          setTimeout(function () { isSubmitting = false; }, 300);
        }
      }

      function maybeReset() {
        var now = (input.value || '').trim();

        // Only reset when going from NON-empty -> empty
        if (prev !== '' && now === '') {
          submitForm();
        }
        prev = now;
      }

      input.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(maybeReset, 150);
      });

      input.addEventListener('blur', maybeReset);

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          input.value = '';
          maybeReset();
        }
      });

      input.addEventListener('search', maybeReset);
    });
  }

  function initSearchAutoReset() {
    bindAutoResetForSellerSearch(document);

    var root = document.querySelector('main#MainContent') || document.body;
    if (!root) return;

    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          bindAutoResetForSellerSearch(document);
          break;
        }
      }
    });

    obs.observe(root, { childList: true, subtree: true });

    setTimeout(function(){ bindAutoResetForSellerSearch(document); }, 800);
    setTimeout(function(){ bindAutoResetForSellerSearch(document); }, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchAutoReset);
  } else {
    initSearchAutoReset();
  }
})();


(function () {
  /* =========================================================
     2) PRODUCT IMAGE PERFORMANCE OPTIMIZATIONS
        - lazyload + async decode
        - first 3 eager/high priority
        - set width/height (reduce layout shift)
        - attempt Shopify CDN resize to _520x (safe fallback)
     ========================================================= */

  function toShopifySizedUrl(url, width) {
    try {
      if (!url) return null;
      if (url.indexOf('cdn.shopify.com/') === -1) return null;

      // Don't rewrite if already resized like _520x.
      if (/_\d+x\./i.test(url)) return null;

      var parts = url.split('?');
      var base = parts[0];
      var qs = parts[1] ? ('?' + parts[1]) : '';

      var m = base.match(/^(.*)\.(jpg|jpeg|png|webp|gif)$/i);
      if (!m) return null;

      return (m[1] + '_' + width + 'x.' + m[2]) + qs;
    } catch (e) {
      return null;
    }
  }

  function enhanceProductImages(root) {
    root = root || document;

    var main = root.querySelector('main[data-template="page.mp_seller_profile"]');
    if (!main) return;

    var imgs = main.querySelectorAll('img.mp-product-image');

    imgs.forEach(function (img, idx) {
      if (img.__wkOptimized) return;
      img.__wkOptimized = true;

      // Keep original in case we need to fall back
      var originalSrc = img.getAttribute('src') || '';
      img.__wkOriginalSrc = originalSrc;

      // Decode async helps main thread
      img.setAttribute('decoding', 'async');

      // Reduce layout shift: provide dimensions (square card assumption)
      if (!img.getAttribute('width')) img.setAttribute('width', '520');
      if (!img.getAttribute('height')) img.setAttribute('height', '520');

      // Prioritize first row; lazy-load the rest
      if (idx < 3) {
        img.setAttribute('loading', 'eager');
        img.setAttribute('fetchpriority', 'high');
      } else {
        img.setAttribute('loading', 'lazy');
        img.setAttribute('fetchpriority', 'low');
      }

      // Try smaller Shopify CDN variant for speed
      var sized = toShopifySizedUrl(originalSrc, 520);

      if (sized && sized !== originalSrc) {
        // Safe fallback on error
        img.addEventListener('error', function () {
          // only fallback if we were trying the sized URL
          if (img.getAttribute('src') === sized && img.__wkOriginalSrc) {
            img.setAttribute('src', img.__wkOriginalSrc);
          }
        }, { once: true });

        img.setAttribute('src', sized);
      }
    });
  }

  function init() {
    enhanceProductImages(document);

    var main = document.querySelector('main[data-template="page.mp_seller_profile"]');
    if (!main) return;

    // Observe dynamic product injection
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) {
          enhanceProductImages(document);
          break;
        }
      }
    });

    obs.observe(main, { childList: true, subtree: true });

    // extra delayed passes
    setTimeout(function () { enhanceProductImages(document); }, 800);
    setTimeout(function () { enhanceProductImages(document); }, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
